

import React, { useEffect, useState } from "react";
import "../assets/employereportnew.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport, deleteEmployee } from "../redux/slices/employeeReportSlice";
import { toast } from "react-toastify";
import EmployeeEditModal from "../modals/EmployeeEditModal";
import axios from "axios";
import { fetchRoles } from "../redux/slices/roleSlice";
import { getBranches } from "../redux/slices/branchSlice";
import { Eye, Trash } from "lucide-react";

const EmployeeReport = () => {
  const dispatch = useDispatch();
  const { list: data, loading, error, currentPage, totalPages } = useSelector(
    (state) => state.employeeReport
  );
    const { items: roles } = useSelector((state) => state.roles);
    const { branches } = useSelector((state) => state.branch);

  // console.log("employee data",data)
  const [filterType, setFilterType] = useState("userId");
  const [filterValue, setFilterValue] = useState("");
  const [branch, setBranch] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
    const [modalConfig, setModalConfig] = useState({
      isOpen: false,
      loanId: null,
      type: "",
    });

  const pageSize = 10;

  const fetchData = (page = 1) => {
    dispatch(
      fetchEmployeeReport({
        page,
        pageSize,
        filterType,
        filterValue,
        branch,
        fromDate,
        toDate,
      })
    );
  };

  useEffect(() => {
    fetchData(1);
  }, []);


    useEffect(() => {
      dispatch(fetchRoles());
      // dispatch(getBranches());
      dispatch(getBranches({ fetchAll: true }));
  
    }, [dispatch]);


const handlepreviewclick = async (id) =>{
  const superAdminId=localStorage.getItem("adminuserId")
  const imageStatus="Approved";
     try {
        const res = await fetch(
          `https://payyug.in/api/list-employee-kyc?userId=${id}&superAdminId=${superAdminId}&status=${imageStatus}`
        );
        const data = await res.json();
        if (res.ok && data.documents?.length > 0) {
          const photoDoc = data.documents.find(
            (doc) => doc.docName?.toLowerCase() === "photo" && doc.status?.toLowerCase()==="approved"
          );

        

          // console.log("photoDoc.docImage");
          console.log(photoDoc.docImage);
          if (photoDoc?.docImage) {
            // setPhotoUrl(`https://payyug.in/uploads/${photoDoc.docImage}`);
            setPreviewImage(`https://payyug.in/uploads/${photoDoc.docImage}`)
          }
        }
       else {
        toast.error("Employee image not Found.")
       }
      } catch (err) {
        console.error("Failed to fetch employee photo:", err);
      }
      
    };

      // Open the modal
  const openModal = (id, type) => {
    setModalConfig({ isOpen: true, loanId: id, type });
  };

  // Close the modal
  const closeModal = () => {
    setModalConfig({ isOpen: false, loanId: null,});
  };


  const handleDelete = async () => {
    const {loanId}=modalConfig
    // if (!window.confirm("Are you sure you want to delete this employee?")) return;
    try {
      await dispatch(deleteEmployee(loanId)).unwrap();
      toast.success("Employee deleted successfully!");
      fetchData(currentPage); // refresh current page
    } catch (err) {
      toast.error(err);
    }finally{
      closeModal();
    }
  };

  // console.log("data is ",data);


  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      fetchData(pageNumber);
    }
  };

  return (
    <div className="CustomerReport-container">
      <h2 className="CustomerReport-heading">Employee Report</h2>

      {/* Filters */}
      <div className="CustomerReport-filterSection">
        <div className="CustomerReport-filterGroup">
          <label>From Date</label>
          <input
            type="date"
            className="CustomerReport-input"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="CustomerReport-filterGroup">
          <label>To Date</label>
          <input
            type="date"
            className="CustomerReport-input"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        {/* <div className="CustomerReport-filterGroup">
          <label>Branch</label>
          <input
            type="text"
            className="CustomerReport-input"
            placeholder="Enter Branch"
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
          />
        </div> */}
        <div className="CustomerReport-filterGroup">
          <label>Filter By</label>
          <select
            className="CustomerReport-input"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="userId">User ID</option>
            {/* <option value="aadhar">Aadhar</option>
            <option value="pan">PAN</option>
            <option value="phone">Mobile</option>
            <option value="dob">DOB</option>
            <option value="name">Name</option> */}
          </select>
        </div>
        <div className="CustomerReport-filterGroup">
          <label>{filterType.toUpperCase()}</label>
          <input
            type={filterType === "dob" ? "date" : "text"}
            className="CustomerReport-input"
            placeholder={`Enter ${filterType.toUpperCase()}`}
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
          />
        </div>
        <div className="CustomerReport-filterGroup buttonWrapper">
          <button className="CustomerReport-submit" onClick={() => fetchData(1)}>
            Submit
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="CustomerReport-tableWrapper">
        {loading ? (
          <p style={{ textAlign: "center" }}>Loading...</p>
        ) : error ? (
          <p style={{ color: "red", textAlign: "center" }}>{error}</p>
        ) : (
          <>
            <table className="CustomerReport-table">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Image</th>
                  <th>Emp. ID</th>
                  <th>User Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Branch</th>
                  <th>Role</th>
                  <th>Aadhar</th>
                  <th>PAN</th>
                  <th>Address</th>
                  <th>DOB</th>
                  <th>Joining Date</th>
                  <th>Update</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((row, index) => (
                    <tr key={row.id}>
                      <td>{(currentPage - 1) * pageSize + index + 1}</td>
                      {/* <td>
                        <img
                          src={`https://ui-avatars.com/api/?name=${row.id}&background=random`}
                          alt="Profile"
                        />
                      </td> */}
                      <td>
                        <button
                          className="preview-btn-emprpt"
                          onClick={() =>
                            handlepreviewclick(row.userId)
                          }
                        >
                          <Eye/>
                        </button>
                      </td>
                     
                      <td>{row.userId||"N/A"}</td>
                      <td>{row.fullName||"N/A"}</td>
                      <td>{row.email||"N/A"}</td>
                      <td>{row.mobileNumber||"N/A"}</td>
                      <td>{row.branchName||"N/A"}</td>
                      <td>{row.roleName||"N/A"}</td>
                      <td>{row.aadhaarNumber||"N/A"}</td>
                      <td>{row.panNumber||"N/A"}</td>
                      <td>{row.address||"N/A"}</td>
                      <td>{new Date(row.dateOfBirth).toLocaleDateString("en-GB")||"N/A"}</td>
                      <td>{new Date(row.dateOfJoining).toLocaleDateString("en-GB")||"N/A"}</td>
                      <td>
                        <button
                          className="CustomerReport-action"
                          onClick={() => {
                            setIsModalOpen(true);
                            setSelectedEmployee(row);
                          }}
                          title="Update"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </td>

                      <td>
                        <button
                          className="CustomerReport-action delete-btn"
                          onClick={() => openModal(row.id, "delete")}
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" style={{ textAlign: "center" }}>
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

         
          </>
        )}
      </div>

      {/* Pagination */}
         {totalPages > 1 && (
              <div className="CustomerReport-paginationCard">
                <div className="CustomerReport-pagination">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>

                  <span className="CustomerReport-pageIndicator">
                    Page {currentPage} of {totalPages}
                  </span>

                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}


            {/* 🔹 Preview Modal */}
            {previewImage && (
              <div className="modal-overlay" onClick={() => setPreviewImage(null)}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                  <img src={previewImage} alt="KYC Preview" className="modal-image" />
                  <button
                    className="modal-close"
                    onClick={() => setPreviewImage(null)}
                  >
                    ×
                  </button>
                </div>
              </div>
            )}

            {/* --- ACTION MODAL --- */}
                  {modalConfig.isOpen && (
                    <div className="loan-pre-closer-modal-overlay">
                      <div className="loan-pre-closer-modal-content">
                        <div className={`loan-pre-closer-modal-icon icon-delete`}>
                          <Trash size={40} />
                        </div>
                        <h2>
                          Confirm{" "}
                          {"delete".charAt(0).toUpperCase() +
                            "delete".slice(1)}
                        </h2>
                        <p>
                          Are you sure you want to <b>delete</b> this loan
                          record? This action might be irreversible.
                        </p>
            
                        <div className="loan-pre-closer-modal-actions">
                          <button className="loan-pre-closer-btn-cancel" onClick={closeModal}>
                            Cancel
                          </button>
                          <button
                            className={`loan-pre-closer-btn-confirm`}
                            style={{backgroundColor:"#dc2626"}}
                            onClick={handleDelete}
                          >
                            Confirm Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

            {/* Edit Modal */}
            <EmployeeEditModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              employee={selectedEmployee}
              onUpdated={() => fetchData(currentPage)}
              branches={branches}
              roles={roles}
            />
    </div>
  );
};

export default EmployeeReport;
